import type { PPSectionData } from "./privacy.data";

interface PPSectionProps {
  section: PPSectionData;
}

export function PPSection({ section }: PPSectionProps) {
  const titleClass = section.isDouble
    ? "legal-section-title double-enum"
    : "legal-section-title";

  return (
    <div className="legal-section">
      <ol start={section.number} className={titleClass}>
        <li className="section-title-label">{section.title}</li>
      </ol>
      <div dangerouslySetInnerHTML={{ __html: section.content }} />
    </div>
  );
}
